import axios from 'axios'
import library from '../../../utils/Library'

export const createInviteOrgStaffUser = async (newInvite) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('invite_api') +
    '/createOrgStaffRegistrationUserInvite'

  return await axios({
    url: URL,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    data: newInvite
  })
}
